import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Helpers from "commons/helpers";
import Strings from "constants/strings";

import { RootState } from "store";
import { DashboardLayout } from "layout";


const DashboardScreen = () => {
    const navigate = useNavigate();
    const firstRoutePath = useSelector((state: RootState) => state.titleRoute.firstRoutePath);
    const workingOrganization = useSelector((state: RootState) => state.user.workingOrganization);

    useEffect(() => {
        if (Helpers.isNullOrEmpty(firstRoutePath) || Helpers.isNullOrEmpty(workingOrganization)) {
            return;
        }
        navigate(firstRoutePath, { replace: true });
    }, [firstRoutePath, workingOrganization]);

    return (
        <DashboardLayout
            isPermission
            title={Strings.APP.HOME}
            route={[{ title: Strings.APP.HOME, route: "" }]}
        >
            <></>
        </DashboardLayout>
    );
};

export default DashboardScreen;
